import { Component, Input, OnInit } from '@angular/core';
import { TileButtonComponent } from '../tile-button/tile-button.component';
import { NgForOf, NgIf } from '@angular/common';
import { DefaultFlexDirective, DefaultFlexOffsetDirective, DefaultLayoutDirective } from 'ng-flex-layout';
import { HandsetService } from '../../../core/services/handset.service';
import { IconComponent } from '../icon/icon.component';

export interface TileButton {
  loading?: boolean;
  disabled?: boolean;
  icon: string;
  iconSize: number;
  title: string;
  titleStyle: any;
  customWidth?: string;
  customHeight?: string;
  customWidthMobile?: string;
  customPadding: string;
  subtitle: string;
  onClickFn: () => void;
  url?: string;
}

@Component({
  standalone: true,
  selector: 'app-tile-buttons-list',
  templateUrl: './tile-buttons-list.component.html',
  styleUrls: ['./tile-buttons-list.component.scss'],
  imports: [
    TileButtonComponent,
    NgForOf,
    DefaultLayoutDirective,
    NgIf,
    DefaultFlexOffsetDirective,
    DefaultFlexDirective,
    IconComponent,
  ],
})
export class TileButtonsListComponent implements OnInit {
  @Input() public buttons: TileButton[];
  @Input() public title: string;
  @Input() public horizontal: boolean;
  @Input() public horizontalMobile: boolean;
  @Input() public listItemMobile: boolean;
  @Input() public customOffset: string;

  constructor(protected handsetService: HandsetService) {
  }

  ngOnInit(): void {
  }

  getGap(index: number): string {
    return index === this.buttons.length - 1 ? '0px' : this.customOffset;
  }

  public onClick(button: TileButton) {
    if (!button.disabled) {
      button.onClickFn();
    }
  }

}
